module.exports = __webpack_public_path__ + "static/media/m-bg-5.a97d832d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/m-bg-5.png
// module id = 58
// module chunks = 3